var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('iframe',{staticClass:"pdfcss",attrs:{"src":("https://wthedu.51suiyixue.com/PDF/web/viewer.html?file=" + _vm.url),"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }